/**
 * AccessHome — thin satellite-app wrapper around the shared "My Access" board.
 * Owns only the standalone-app page chrome: title, ReturnToMainAgent, MainAppNav.
 *
 * The board is wired to the live access surface via AccessBoardConnected (GET
 * /me/access/overview + resources + /access-requests). Home is session-less, so
 * the board renders read-only except the composer: its first send mints the
 * session (useDeferredFirstSend) and onSessionCreated navigates into it — there
 * is no empty-session "open assistant" step, because tricorder-session creates
 * a session WITH its first message, never without one.
 * The DEV /preview route keeps the design fixtures.
 */

import { ReturnToMainAgent } from '@frontend/components/ReturnToMainAgent'
import { MainAppNav } from '@frontend/components/MainAppNav'
import { AccessBoardConnected } from '../components/access/AccessBoardConnected'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function AccessHome() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className="flex h-dvh flex-col bg-[var(--color-surface-canvas,#ffffff)]">
      <header className="flex items-center gap-2 border-b border-neutral-200 bg-white px-4 py-3 pt-[max(0.75rem,env(safe-area-inset-top))]">
        <ReturnToMainAgent className="-ml-2" />
        <h1 className="min-w-0 flex-1 truncate text-[19px] font-semibold tracking-[-0.01em] text-neutral-900">
          {t('access.board.title')}
        </h1>
        <MainAppNav />
      </header>

      <main className="min-h-0 flex-1 overflow-y-auto">
        <AccessBoardConnected onSessionCreated={(s) => navigate(`/sessions/${s.id}`)} />
      </main>
    </div>
  )
}
